import { Dialog, Button } from "@justworkshr/milo-components";

interface InvalidDialogProps {
  isOpen: boolean;
  onContinue: () => void;
  onReview: () => void;
}

const InvalidDialog = ({
  isOpen,
  onContinue,
  onReview,
}: InvalidDialogProps) => {
  return (
    <Dialog
      title="We weren't able to validate your address"
      primaryButton={
        <Button onClick={onReview} size="sm">
          Update
        </Button>
      }
      secondaryButton={
        <Button onClick={onContinue} size="sm" variant="ghost">
          Continue
        </Button>
      }
      size="md"
      showCloseButton={false}
      isOpen={isOpen}
    >
      <p>If you're sure it's correct, you can continue.</p>
    </Dialog>
  );
};

export default InvalidDialog;
